import * as yup from "yup";

import { TStreetOptionDataResponse } from "../types";

const streetOptionSchema = yup.object({
  address: yup.object({
    label: yup.string(),
    countryCode: yup.string(),
    countryName: yup.string(),
    state: yup.string(),
    county: yup.string(),
    city: yup.string(),
    district: yup.string(),
    street: yup.string(),
    postalCode: yup.string(),
    houseNumber: yup.string(),
  }),
});
export const validateStreetOptionData = (responseData: any): TStreetOptionDataResponse =>
  streetOptionSchema.validateSync(responseData);
